import { useCallback, useLayoutEffect, useRef } from "react";
import useProjectContext from "@/services/context/project/use-project-context";
import ProjectLockStatus from "@/models/enums/project-lock-status";
import useProjectProcessContext from "./use-project-process-context";

const useProjectEditAccess = () => {
    const { projectLockStatus } = useProjectContext();
    const { isProcessRunning, isLoading, isProcessStatusKnown, isProcessBlockingEdits } = useProjectProcessContext();
    const isOwned = projectLockStatus === ProjectLockStatus.LOCK_OWNED;
    const ownedRef = useRef(isOwned);

    useLayoutEffect(() => {
        ownedRef.current = isOwned;
    }, [isOwned]);

    const isBlockedByProcess = isProcessRunning || isLoading || !isProcessStatusKnown;
    let reason: string | undefined;
    if (isProcessRunning) {
        reason = "Processus en cours : consultation uniquement.";
    } else if (isLoading) {
        reason = "Vérification du processus en cours...";
    } else if (!isProcessStatusKnown) {
        reason = "Impossible de vérifier le processus. Réessayez avant de modifier le projet.";
    } else if (!isOwned) {
        reason = "Prenez la main sur le projet pour le modifier.";
    }

    const ensureCanEdit = useCallback(() => ownedRef.current && !isProcessBlockingEdits(), [isProcessBlockingEdits]);

    return { canEdit: isOwned && !isBlockedByProcess, isBlockedByProcess, reason, ensureCanEdit };
};

export default useProjectEditAccess;
